"use client"

import React from "react"
import Link from "next/link"
import { useRouter, useParams, usePathname } from "next/navigation"
import Stack from "@mui/material/Stack"
import i18nConfig from "@i18nConfig"
type Props = {
  [x: string]: any;
  checkActive?: boolean;
  sx?: any;
  children: any;
  skipLocaleHandling?: boolean;
  colorHover?: string;
  className?: string;
  /** Enable Next.js prefetch (RSC request) — default OFF to avoid origin
   *  round-trips for every viewport link. Opt in for above-the-fold (logo,
   *  primary menu, login CTA). */
  prefetch?: boolean;
}
const NextLink = ({
  checkActive,
  sx,
  children,
  skipLocaleHandling,
  colorHover,
  className,
  onClick,
  style,
  passHref,
  prefetch = false,
  target = "_self",
  ...rest
}: Props) => {
  const router = useRouter()
  const params = useParams()
  const pathname = usePathname()

  const locale = rest.locale || params.locale || ""

  let href = rest.href || ""
  if (href && href.indexOf("http") === 0) skipLocaleHandling = true
  const shouldPrefixLocale = locale && locale !== i18nConfig.defaultLocale
  if (shouldPrefixLocale && !skipLocaleHandling) {
    href = href ? `/${locale}${href}` : pathname.replace("[locale]", locale)
  }

  return (
    <Stack
      sx={{
        "& a": {
          color: "#000",
          fontSize: 14,
          textDecoration: "none",
          "&:hover": {
            color: colorHover || "#3f80e6"
          }
        },
        ...sx
      }}
    >
      <Link style={style} className={className} href={href} onClick={onClick} passHref={passHref} target={target} prefetch={prefetch}>
        {children}
      </Link>
    </Stack>
  )
}

export default NextLink
